import { useTranslation } from "react-i18next";
import React, { useState } from "react";
import { useDroppable } from "@dnd-kit/core";
import { SortableContext, verticalListSortingStrategy } from "@dnd-kit/sortable";
import { LessonContainer } from "./LessonContainer";
import DragItem from "./DragItem";
import { Chapter } from "./types";
import AddChapter from "../../../../drawer/add-chapter/AddChapter";

export function ChapterContainer({ chapter, dataConfig }: { chapter: Chapter, dataConfig: Chapter }) {
  const { t } = useTranslation();
  const { setNodeRef, isOver } = useDroppable({ id: `chapter-${chapter.id}` });
  const [isOpenDrawer, setIsOpenDrawer] = useState(false);

  return (
    <div ref={setNodeRef} style={{ background: isOver ? "#e6f7ff" : "#fff", marginBottom: 12, borderRadius: 8 }}>
      <DragItem item={chapter} type="CHAPTER" dataConfig={dataConfig} />
      <SortableContext items={chapter.children.map((l) => l.id)} strategy={verticalListSortingStrategy}>
        {chapter.children.map((lesson) => (
          <LessonContainer key={lesson.id} lesson={lesson} dataConfig={dataConfig} />
        ))}
      </SortableContext>
      <div className="add-chapter-btn"
        onClick={() => setIsOpenDrawer(true)}
      >
        <div>+</div>
        {t("Thêm bài giảng", "Thêm bài giảng")}
      </div>

      {isOpenDrawer &&
        <AddChapter
          id={chapter.id}
          setIsOpenDrawer={setIsOpenDrawer}
          open={isOpenDrawer}
          itemDetail={chapter}
          isLesson={true}
          isEdit={false}
        />}
    </div>
  );
}
